module.exports = __webpack_public_path__ + "static/hero-4-3e9c2f0c5fcb2ce24cbe19c01dab7810.jpg";